import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import { PdpSharedPaymentCardsLazy } from './PdpSharedPaymentCards/PdpSharedPaymentCardsLazy';

import styles from './PdpSharedDetailPayments.scss';

function PdpSharedDetailPaymentsComponent(props) {
    const { isClient, item, user, currency, viewer } = props;

    return (
        <Fragment>
            <FormattedMessage
                id="pdpDetails.paymentsPolicy"
                defaultMessage="1stdibs accepts the following payment methods"
            />
            <div data-tn="pdp-spec-payment-methods" className={styles.container}>
                {isClient && (
                    <React.Fragment>
                        <React.Suspense fallback="">
                            <PdpSharedPaymentCardsLazy
                                item={item}
                                currency={currency}
                                user={user}
                                viewer={viewer}
                            />
                        </React.Suspense>
                    </React.Fragment>
                )}
            </div>
        </Fragment>
    );
}

PdpSharedDetailPaymentsComponent.propTypes = {
    currency: PropTypes.string,
    viewer: PropTypes.object.isRequired,
    user: PropTypes.object,
    item: PropTypes.object.isRequired,
    isClient: PropTypes.bool.isRequired,
};

export const PdpSharedDetailPayments = createFragmentContainer(PdpSharedDetailPaymentsComponent, {
    viewer: graphql`
        fragment PdpSharedDetailPayments_viewer on Viewer {
            affirmEnabled: isEnabledByLocale(featureName: "AFFIRM")
            regionalInfo {
                countryCode
            }
        }
    `,
    user: graphql`
        fragment PdpSharedDetailPayments_user on User {
            isVip
            isVerifiedTrade
            canSeeNetPrice: hasPermission(name: "B_NET_PRICE")
            canCheckoutWithCheck: hasPermission(name: "B_CHECKOUT_CHECK")
        }
    `,
    item: graphql`
        fragment PdpSharedDetailPayments_item on Item {
            pdpTypeDisplay
            affirmDisplayInfo: displayInfo {
                showAffirmPromo
            }
            pricing {
                prices {
                    type
                    status
                    amount {
                        convertedAmounts {
                            USD
                        }
                    }
                }
            }
        }
    `,
});
